import { Box, Chip, OutlinedInput } from '@mui/material';
import { styled } from '@mui/material/styles';

const DefaultForm = ({
  label,
  value,
  mt,
  chip,
  inputType,
  userInfo,
  isReadOnly,
  isBorder,
}: {
  label: string;
  value?: string;
  mt?: number;
  chip?: boolean;
  inputType?: string;
  userInfo?: string;
  chipBorderWidth?: string;
  inputBorderWidth?: string;
  isReadOnly?: boolean;
  isBorder?: boolean;
}) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      mt={mt}
      flex={!chip ? 1 : 0}
    >
      {isBorder ? <StyledBorderChip label={label} /> : <StyledChip label={label} />}
      {!chip && (
        <StyledOutlinedInput
          id={value}
          defaultValue={userInfo}
          readOnly
        />
        // {value}
        // </StyledOutlinedInput>
      )}
    </Box>
  );
};

const StyledChip = styled(Chip)(({ theme }) => ({
  minWidth: '150px',
  height: '40px',
  backgroundColor: '#d2d2d2',
  color: '#000',
  borderRadius: '0',
}));

const StyledBorderChip = styled(Chip)(({ theme }) => ({
  minWidth: '150px',
  height: '40px',
  backgroundColor: '#d2d2d2',
  color: '#000',
  borderRadius: '0',
  borderRight: '1px solid #000',
}));

const StyledOutlinedInput = styled(OutlinedInput)(({ theme }: any) => ({
  width: '100%',
  backgroundColor: '#ffffff',
  color: '#000000',
  borderRadius: '0',
  maxHeight: '40px',
  '& .MuiOutlinedInput-notchedOutline': {
    display: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    display: 'none',
  },
}));

export default DefaultForm;
